import React from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';

// import cogSrc from './assets/cog.svg';

const NavWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  border-bottom: 1px solid ${props => props.theme.border};
`;

const TabsWrapper = styled.nav`
  display: flex;
  gap: 40px;
`;

const TabButton = styled.button<{ active?: any }>`
  padding: 0 0 36px;
  margin-bottom: 0px;

  background: transparent;
  border: none;
  border-bottom: 4px solid transparent;

  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.text2};
  text-transform: uppercase;
  text-decoration: none;

  cursor: pointer;

  ${props =>
    props.active &&
    css`
      border-color: #0a090e;

      color: #0a090e;
    `}
`;

// const SettingsButton = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   height: 36px;
//   width: 36px;

//   border-radius: 4px;
//   border: none;
//   box-shadow: 0 12px 26px 0 rgba(0, 0, 0, 0.06);
//   background-color: #f5f5fc;
// `;

export default function WalletNav({ navItems }: { navItems: WalletTabData[] }) {
  return (
    <NavWrapper>
      <TabsWrapper>
        {navItems.map((item: WalletTabData) => (
          <NavLink key={item.key} role="tab" to={`/wallet/${item.key}`}>
            {({ isActive }) => <TabButton active={isActive}>{item.label}</TabButton>}
          </NavLink>
        ))}
      </TabsWrapper>
      {/*      <SettingsButton type="button">
        <img src={cogSrc} alt="" />
      </SettingsButton>*/}
    </NavWrapper>
  );
}
